export enum SearchFieldType {
    DateBetween = "DateBetween",
    NumberBetween = "NumberBetween",
    Boolean = "Boolean",
    ReverseBoolean = "ReverseBoolean",
    Text = "Text",
    Date = "Date",
    Number = "Number",
    Select = "Select"
}
export  class FieldSelect  {
    items:any[] =[];
    itemText:string="";
    itemValue:string="";
}
export default class SearchFields{
    name:String = "";
    label:String = "";
    type:SearchFieldType = SearchFieldType.Text;
    operator:String = "";
    value:any;
    value2:any;
    data: FieldSelect | any = new FieldSelect();
    active:Boolean=true;
}


